// Three dots lighting up in turn, in the current text colour: the one sign
// of a wait (design.md rule 11) -- the syncing flash line (FlashBanner), the
// onboarding's and Sync new leagues' waits, and a busy button (SubmitButton,
// Connect ESPN), where they stand in for the label. Decorative -- aria-hidden,
// the text beside it carries the meaning -- and still under
// prefers-reduced-motion, where the three dots simply show. The animation
// is the `dots` keyframes in entrypoints/application.css (`--animate-dots`).
const DELAYS = ['[animation-delay:0s]', '[animation-delay:0.2s]', '[animation-delay:0.4s]']

export default function PulsingDots() {
  return (
    <span aria-hidden="true" className="inline-flex items-center gap-1">
      {DELAYS.map((delay) => (
        <span key={delay} className={`h-1.5 w-1.5 rounded-full bg-current animate-dots motion-reduce:animate-none ${delay}`} />
      ))}
    </span>
  )
}
